module.exports = __webpack_public_path__ + "static/media/leading_healthcare_illustration.29d78b5b.svg";